import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pb-2"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "px-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!
  const _component_video_details_category_sub_contents = _resolveComponent("video-details-category-sub-contents")!

  return (Array.isArray(_ctx.subs) && _ctx.subs.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subs, (sub, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: sub.id
          }, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.handleToggle(index)),
              class: "font-semibold text-gray-700 px-3 cursor-pointer flex items-center hover:underline"
            }, [
              _createVNode(_component_base_svg_icon, {
                class: _normalizeClass(["w-6 transform transition-transform duration-500 cursor-pointer", _ctx.isOpenSub[index] ? 'rotate-90' : 'rotate-0']),
                path: _ctx.mdiChevronRight
              }, null, 8, ["class", "path"]),
              _createElementVNode("div", null, _toDisplayString(sub.name), 1)
            ], 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_video_details_category_sub_contents, {
                isOpen: _ctx.isOpenSub[index],
                videos: sub.videos
              }, null, 8, ["isOpen", "videos"])
            ])
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}